export const defaultOptions = [
  { id: 1, text: 'option 1' },
  { id: 2, text: 'option 2' },
  { id: 3, text: 'option 3' },
  { id: 4, text: 'option 4' },
];
